export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          了解刃牙漫画平台的初心与使命
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">
                  刃牙漫画 —— 一站式热血格斗漫画阅读平台
                </h3>
                <div className="space-y-3 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    刃牙漫画平台致力于为广大格斗漫画爱好者提供最完整的刃牙系列阅读体验。从板垣惠介老师的经典原作第一部，到正在连载中的刃牙道II相扑道篇，我们收录了刃牙漫画完整版全部章节。
                  </p>
                  <p>
                    平台采用下拉式阅读设计，让读者可以无缝畅享刃牙漫画大全。无论是在电脑上细细品味每一格的画功，还是在手机上随时随地追更，我们都力求提供流畅的阅读体验。
                  </p>
                  <p>
                    刃牙漫画合集持续同步更新，确保读者第一时间读到最新内容。每一个篇章、每一次对决，都在这里完整呈现。
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {[
                  { num: '30+', label: '年连载历史' },
                  { num: '1200+', label: '全系列章节' },
                  { num: '7', label: '系列作品' },
                  { num: '10万+', label: '忠实读者' },
                ].map((stat, i) => (
                  <div key={i} className="text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600 mb-1">{stat.num}</div>
                    <div className="text-xs text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}